import { makeStyles } from "@fluentui/react-components";

export const getAppTooltipStyles = makeStyles({
  root: {
    maxWidth: "350px",
  },
});
